export default __webpack_public_path__ + "static/media/jen_membership1.3d75a829.svg";